import { useUploaderService } from '@/layout/appWrapper/ServiceProvider';
import { useLocalization } from '@/services/localizationService';
import { mediaShownInComparerState } from '@/stores/mediaStore';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

function SizeView({
  className = '',
  width = '- ',
  height = '- ',
}: {
  className?: string;
  width?: number | string;
  height?: number | string;
}) {
  const { t, data } = useLocalization();

  return (
    <div className={`flex space-s-6 ${className}`}>
      <p className="space-s-2">
        <span className="M16 contrast-low lg:hidden">
          {t(data.result.width.charAt(0))}:
        </span>
        <span className="M16 contrast-low hidden lg:inline">
          {t(data.result.width)}:
        </span>
        <span className="M16 contrast-high">{width}px</span>
      </p>
      <p className="space-s-2">
        <span className="M16 contrast-low lg:hidden">
          {t(data.result.height.charAt(0))}:
        </span>
        <span className="M16 contrast-low hidden lg:inline">
          {t(data.result.height)}:
        </span>
        <span className="M16 contrast-high">{height}px</span>
      </p>
    </div>
  );
}

function Size({ ...rest }) {
  const image = useRecoilValue(mediaShownInComparerState);
  const { loadImage } = useUploaderService();

  const [outputImageElement, setOutputImageElement] =
    useState<HTMLImageElement>();

  useEffect(() => {
    const loadOutputImage = async () => {
      setOutputImageElement(undefined);
      if (!image.outputUrl) return;
      const imgElement = await loadImage(image.outputUrl);
      setOutputImageElement(imgElement);
    };

    loadOutputImage();
  }, [image, loadImage]);

  const placeholder = <SizeView />;

  if (!outputImageElement) return placeholder;

  return (
    <SizeView
      width={outputImageElement.width}
      height={outputImageElement.height}
      {...rest}
    />
  );
}

export default Size;
